import React, { forwardRef, Ref } from 'react';
import { SimpleIconProps } from '../icon.types';
import Icon from './Icon';

const svg = `<svg viewBox="0 0 24 24" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" fill="none">
  <path d="M12 12h.01"/>
  <path d="M16 6V4a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v2"/>
  <path d="M22 13a18.15 18.15 0 0 1-20 0"/>
  <rect width="20" height="14" x="2" y="6" rx="2"/>
</svg>`;

const Business = forwardRef(
  (props: SimpleIconProps, ref: Ref<SVGSVGElement> | undefined) => (
    <Icon ref={ref} name='business' svg={svg} {...props} />
  )
);

Business.displayName = 'BusinessIcon';

export default Business;
